export default {
      id: "arrow-left-usage",
      viewBox: "0 0 22.956 10.773",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#arrow-left",
      toString: function () {
        return this.url;
      }
    }